import type {
	LWApiPublicAccountUserDetailsResultRawI,
	LWApiPublicAccountUserListResultRawI,
} from '@liquidweb-dev/club-sauce/public/account/user/index.raw';

export const mergeUsersFromListQueriesData = (
	queriesData: (LWApiPublicAccountUserListResultRawI | undefined)[],
	username: string,
): LWApiPublicAccountUserDetailsResultRawI | undefined => {
	const matchingUsers = queriesData
		.flatMap((queryData) => queryData?.items || [])
		.filter((user) => user?.username === username);

	if (matchingUsers.length === 0) return undefined;

	return matchingUsers.reduce<LWApiPublicAccountUserDetailsResultRawI>(
		(merged, user) => ({ ...merged, ...user }),
		matchingUsers[0],
	);
};

export default mergeUsersFromListQueriesData;
